<span>
  <mat-form-field
    appearance="fill"
    matAutocompleteOrigin
    #searchorigin="matAutocompleteOrigin"
    class="event-search"
    >
    <input
      matInput
      id="event-search-input"
      name="event-search-input"
      placeholder="Search events"
      [matAutocompleteConnectedTo]="searchorigin"
      [matAutocomplete]="searchauto"
      [formControl]="searchText"
      />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <mat-autocomplete #searchauto="matAutocomplete" class="company-event-search-results">
    @if (store!=null && store.length>0) {
      <span >
        @if (searchEvents && !loading) {
          <span>
            @for (section of searchEvents; track section) {
              @if (section['data']?.length > 0) {
                <mat-optgroup class="option-group"
                  [label]="!section.isPast ? 'Upcoming' : 'Past' "
                  >
                  @for (val of section['data']; track val) {
                    <mat-option
                      sort
                      [value]="val.data.title"
                      class="event-option"
                      (click)="searchRedirect(val.data.id)"
                      >
                      {{ val.data.title }}
                      <span>
                        <br />
                        <span>
                          @if ((val.activeEventDate.start_date && val.activeEventDate.end_date==null) || (val.activeEventDate.start_date == val.activeEventDate.end_date)) {
                            <small
                              class="search-details"
                              >{{ val.activeEventDate.start_date | date }}</small
                              >
                            }
                            @if ((val.activeEventDate.start_date && val.activeEventDate.end_date!==null) && val.activeEventDate.start_date !== val.activeEventDate.end_date) {
                              <small
                                class="search-details"
                                >
                                {{ val.activeEventDate.start_date | date }}  -  {{ val.activeEventDate.end_date | date}}
                              </small>
                            }
                          </span>
                        </span>
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              }
            </span>
          }
          @if (!searchEvents.length && store.length > 1 && !loading) {
            <mat-option
              >
              No matching results.
            </mat-option>
          }
          @if (loading) {
            <mat-option>
              <span class="search-load"
                ><mat-spinner [diameter]="15"></mat-spinner>Loading...</span
                >
              </mat-option>
            }
          </span>
        }
      </mat-autocomplete>
    </span>
